module.exports = __webpack_public_path__ + "media/app/close-8fa014255a04a64e1d9d8a92f4746ff7.svg";